import React from "react";
import "../assets/css/HowItWork.css";
import Leveraging_img from "../assets/images/How_it_images/Leveraging Cisco Meraki Dashboard API.svg";
import on_demand_img from "../assets/images/How_it_images/How We Back Up (Icon)/On-demand.svg";
import Automatic_img from "../assets/images/How_it_images/How We Back Up (Icon)/Automatic.svg";
import Organization_setting from "../assets/images/How_it_images/How We Back Up (Icon)/Organization-wide settings.svg";
import Network_setting from "../assets/images/How_it_images/How We Back Up (Icon)/Network-wide settings.svg";
import Device_specific from "../assets/images/How_it_images/How We Back Up (Icon)/Device-specific settings.svg";
import Restore_img from "../assets/images/How_it_images/How We Restore/How We Restore.svg";
import Map from "../assets/images/How_it_images/Map.svg";
import { useNavigate } from "react-router-dom";

const HowItWork = () => {
  const navigate = useNavigate();

  const handleContactus = () => {
    navigate("/about-us#contact-us");
  };
  return (
    <>
      <div className="container leve-main-container">
        <h1 className="text-center">How It Works</h1>
        {/* ----------------------Leveraging Cisco section------------------- */}
        <div className="lev-cisco container d-flex">
          <div className="col-md-6 img-div">
            <img src={Leveraging_img} alt="image" />
          </div>
          <div className="col-md-6 content-div">
            <h2>Leveraging Cisco Meraki Dashboard API</h2>
            <p>
              Cisco Meraki’s Dashboard API provides a robust, programmatic way
              to manage network configurations. Our service harnesses this
              powerful interface to give you a streamlined process for both
              backing up and restoring your Cisco Meraki Dashboard settings. By
              handling all API calls on your behalf and storing data in a
              secure, fully managed Cloud environment, we offer peace of mind at
              every stage. Your API key is encrypted and used solely to perform
              the authorized operations you request, ensuring that your network
              remains both accessible and protected.
            </p>
          </div>
        </div>
      </div>
      {/*---------------------- How We Back Up section--------------------- */}
      <section className="back-up-section">
        <div className="container">
          <div className="backup-main-div">
            <h2 className="text-center">How We Back Up</h2>
            {/* -------section 1------ */}
            <div className="backup-inner-1">
              <p className="text-center para-init">
                When a backup is initiated, our system collects configuration
                data from your Cisco Meraki Dashboard. Under the hood, this
                process involves making API calls on your behalf that retrieve
                every relevant detail, from organization-level settings to
                network configurations and device-specific parameters.
              </p>
              <p className="text-center para-modes">
                There are two main backup modes:
              </p>
              <div className="cards-div container d-flex">
                {/* Card 1 on demand */}
                <div className="on-demand-card">
                  <img src={on_demand_img} alt="on demand" />
                  <h5>On-demand</h5>
                  <p>Triggered manually by a user</p>
                </div>
                {/* card 2 Automatic */}
                <div className="automatic-card">
                  <img src={Automatic_img} alt="Automatic" />
                  <h5>Automatic</h5>
                  <p>
                    Scheduled to run daily, weekly, or monthly, based on
                    user-defined preferences
                  </p>
                </div>
              </div>
            </div>
            {/* -------section 2-------- */}
            <div className="backup-inner-2">
              <p className="text-center  coll-data">
                After collecting your data, we compile it into a single archive
                file. Within this archive, you’ll find three main folders which
                correspond to:
              </p>
              {/* Cards section */}
              <div className="cards-div container d-flex bac-cards-div">
                {/* Card 1 on demand */}
                <div className="organization-card">
                  <img src={Organization_setting} alt="Org" />
                  <h5>Organization-wide settings</h5>
                </div>
                {/* card 2 Automatic */}
                <div className="network-card">
                  <img src={Network_setting} alt="network" />
                  <h5>Network-wide settings</h5>
                </div>
                <div className="device-card">
                  <img src={Automatic_img} alt="device" />
                  <h5>Device-specific settings</h5>
                </div>
              </div>
              {/* last para */}
              <p className="text-center each-fol-para">
                Each folder contains respective JSON files that capture
                everything from VLAN details and DHCP settings to port
                assignments. These files provide a comprehensive snapshot of
                your configuration. Meanwhile, we maintain a Backup History in
                your account, allowing you to view and manage multiple backups
                over time. If you prefer, you can download the backup file and
                store it locally for an additional layer of security.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* ---------------------How We Restore section------------------------ */}
      <div className="container ">
        <div className="how-work-contai">
          <div className="d-flex how-we-res">
            <div className=" col-md-6 left-div">
              <h2>How We Restore</h2>
              <p className="res-para-1">
                The restore process begins by comparing your current Meraki
                Dashboard settings with the data in your backup archive. If the
                configuration you have in place already matches what’s in the
                backup, our system skips those settings. For anything that
                diverges — whether it’s a missing VLAN or a misconfigured device
                — our service attempts to restore the missing data by creating,
                deleting, or modifying your settings to match the exact state
                captured in your backup. Under the hood, we handle all necessary
                API calls on your behalf.
              </p>
              <p className="res-para-2">
                Partial restore options are available to minimize impact and
                focus on specific aspects of your configuration:
              </p>
              <div className="res-cards-div container d-flex">
                <div className="card-res-first">
                  <img src={Organization_setting} alt="org" />
                  <h5 className="text-center">Organization-wide</h5>
                  <p>Rolls back all organization-level settings.</p>
                </div>
                <div className="card-res-second">
                  <img src={Network_setting} alt="network" />
                  <h5 className="text-center">Network</h5>
                  <p>
                    Rolls back network-wide settings and device-specific
                    configurations.
                  </p>
                </div>
              </div>
              <p className="last-after-para desktop-version">
                After the restore completes, you are provided with a
                comprehensive report itemizing each step. This report details
                the configurations that remained unchanged, those that were
                updated, and any that could not be restored — such as missing
                devices or incompatible settings. It also includes raw JSON data
                so you can verify the exact changes that took place.
              </p>
            </div>
            <div className="col-md-6 right-image-div">
              <img src={Restore_img} alt="restore image" />
              <p className="last-after-para mobile-version">
                After the restore completes, you are provided with a
                comprehensive report itemizing each step. This report details
                the configurations that remained unchanged, those that were
                updated, and any that could not be restored — such as missing
                devices or incompatible settings. It also includes raw JSON data
                so you can verify the exact changes that took place.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* ------------------How We Store Your Data section------------------- */}
      <section className="store-data-sec">
        <div className="container">
          <h2 className="text-center">How We Store Your Data</h2>
          <p className="store-para-1 text-center">
            We store your backups in our secure cloud environment for easy,
            on-demand access. All data is encrypted in transit and at rest to
            meet stringent security standards and protect your information at
            every stage.
          </p>
          <p className="store-para-2 text-center">
            To serve a global customer base, we leverage AWS Cloud Services. You
            have the flexibility to choose where your data resides, selecting
            from multiple world’s regions listed below:
          </p>
        
          <div style={{ position: "relative", width: "100%", height: "450px", overflow: "hidden" }}>
  <iframe
    src="https://www.google.com/maps/d/u/2/embed?mid=1pzxQopLNChuJ85gjysZZk0wp-uodO74&ehbc=2E312F&noprof=1"
    style={{
      position: "relative",
      top: "-47px",         
      width: "100%",
      height: "490px",      
      border: "0",
    }}
    allowFullScreen=""
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
  ></iframe>
</div>
          <p className="text-center store-para-3">
            You can also download your backups at any time to maintain your own
            local copies, and you’re free to delete your data from our servers
            whenever you choose. This flexibility gives you complete control
            over your network’s backup storage and ensures that your critical
            configuration is always within reach.
          </p>
        </div>
      </section>
      {/* -------------------------Any Questions section------------------- */}
      <div className="container last-question-div">
        <h2 className="text-center">Any Questions?</h2>
        <p>
          Our goal is to make backing up, restoring, and storing your Meraki
          Dashboard configuration as straightforward and secure as possible. If
          you have any concerns or questions about the process, feel free to
          reach out!
        </p>

        <button
          className="btn main-btn"
          type="button"
          onClick={handleContactus}
        >
          Contact Us
        </button>
      </div>
    </>
  );
};

export default HowItWork;
